import { Box } from "@mui/material";
import { FC } from "react";
import { Button } from "react-admin";

interface StepNavigationButtonsProps {
  activeStep: number;
  steps: string[];
  handleNext: () => void;
  handleBack: () => void;
}

export const StepNavigationButtons: FC<StepNavigationButtonsProps> = ({
  activeStep,
  steps,
  handleNext,
  handleBack,
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "end", gap: 2 }}>
      <Button disabled={activeStep === 0} onClick={handleBack} label="Back" size="large" variant="outlined" />
      <Button
        variant="contained"
        color="primary"
        onClick={handleNext}
        label="Next"
        size="large"
        disabled={activeStep === steps.length - 1}
      />
    </Box>
  );
};
